module.exports = __webpack_public_path__ + "static/media/enroutelogo.d91b6d12.png";